export default "__VITE_ASSET__DWaeB65x__"